import { render } from "./Standard.vue?vue&type=template&id=d6cf6d6a"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Standard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d6cf6d6a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d6cf6d6a', __exports__)) {
    api.reload('d6cf6d6a', __exports__)
  }
  
  module.hot.accept("./Standard.vue?vue&type=template&id=d6cf6d6a", () => {
    api.rerender('d6cf6d6a', render)
  })

}


export default __exports__